import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=cb9b776a&scoped=true&"
import script from "./MailEditor.vue?vue&type=script&lang=js&"
export * from "./MailEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailEditor.vue?vue&type=style&index=0&id=cb9b776a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9b776a",
  null
  
)

export default component.exports